{
  "account.account": "Profile & Security",
  "account.accountDeleted": "Your account has been successfully deleted.",
  "account.accountDescription": "Name, password, delete account",
  "account.accountSection": "Account",
  "account.changeEmail": "Change email",
  "account.changePassword": "Change password",
  "account.currentPassword": "Current password",
  "account.dangerZone": "Danger zone",
  "account.deleteAccount": "Delete your account",
  "account.deleteAccountConfirmation": "Are you sure you want to delete your account? This action is irreversible.",
  "account.deleteAccountDescription": "This action deletes your account and all your information. There is no going back.",
  "account.emailChange": "Change email address",
  "account.emailChangeConfirmation": "Email Change Confirmation",
  "account.emailChangeFailure": "The email change link is invalid or has expired.",
  "account.emailChangeIntro": "Enter your new email address and your current password. We will send a link to the new address: your email changes only once you open it.",
  "account.emailChangeSuccess": "Your email has been successfully changed to {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Your email address has been successfully changed.",
  "account.emailChangeVerificationSent": "A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change.",
  "account.manageAccount": "Manage account",
  "account.newEmailAddress": "New email address",
  "account.newPassword": "New password",
  "account.newPasswordAgain": "New password again",
  "account.oldPassword": "Old password",
  "account.passwordChange": "Password change",
  "account.passwordChangeDescription": "Keep your account secure",
  "account.passwordUpdated": "Password successfully updated.",
  "account.profile": "Profile",
  "account.profileUpdated": "Profile successfully updated.",
  "account.signedInAs": "Signed in as",
  "account.updateYourProfile": "Update your profile",
  "account.updateYourProfileDescription": "Name and display preferences",
  "addons.accountOnHold": "Your account connection has expired. Please reconnect to resume data updates.",
  "addons.accountOnHoldTitle": "Account on hold",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Create and retrieve your API key from this link",
  "addons.ambientWeatherDescription": "Ambient Weather stations (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API key",
  "addons.applicationKey": "Application key",
  "addons.availableServices": "Available",
  "addons.cannotDisconnectLastAccount": "Cannot disconnect your only login method. Please add another login method first.",
  "addons.connect": "Connect",
  "addons.connected": "Connected",
  "addons.connectedAccounts": "Connected Accounts",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Connected",
  "addons.connectedSince": "Connected since {date}",
  "addons.connectionSection": "Connection",
  "addons.connectionSuccess": "{provider} account connected successfully",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API Key",
  "addons.davisDescription": "Davis weather stations (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Retrieve your V2 API keys from this link",
  "addons.disconnect": "Disconnect",
  "addons.disconnectConfirmation": "Are you sure you want to disconnect your {provider} account?",
  "addons.disconnectionSuccess": "{provider} account disconnected successfully",
  "addons.disconnectProviderDescription": "Stops syncing. Your history is kept.",
  "addons.ecowittCreateAndRetrieveKeys": "Create and retrieve both an API key and an application key from this link",
  "addons.ecowittDescription": "Ecowitt provides professional wifi weather station, wireless indoor outdoor thermometers, humidity monitors, high precision rain gauges, air quality monitors and more.",
  "addons.helpLink": "How to connect {provider}",
  "addons.integrationsSection": "Integrations",
  "addons.myAcuriteAccountOnHold": "Your account has been placed on hold. Please enter your password to reconnect your account",
  "addons.myAcuriteDescription": "AcuRite is the #1 weather station brand in North America. As a leader in time, temperature, and weather technology, AcuRite provides you with detailed information about your indoor and outdoor environment so you can plan your day with confidence.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Use your Netatmo Thermostat to change your home's temperature, from your bed or from the other side of the world.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Your personal weather station at home",
  "addons.notConnected": "Not connected",
  "addons.or": "or",
  "addons.providerAccountDisconnected": "The connection to your weather service has expired. Please reconnect to resume data updates.",
  "addons.reconnect": "Reconnect",
  "addons.socialConnectionsIntro": "Link your social accounts to enable quick sign-in. You can connect or disconnect accounts at any time.",
  "addons.weatherflowCreateToken": "Create and retrieve your token from this link",
  "addons.weatherflowTempestDescription": "Tempest Weather System with Built-in Wind Meter, Rain Gauge",
  "addons.weatherServices": "Weather Services",
  "addons.weatherServicesConnected": "{count, plural, =0 {No services connected} one {# service connected} other {# services connected}}",
  "addons.weatherServicesDescription": "Connect Netatmo, Davis, Weatherflow, and more",
  "addons.wundergroundApiKey": "API key",
  "addons.wundergroundDescription": "Weather Underground is a global community of people connecting data from environmental sensors like weather stations and air quality monitors so we can provide the rich, hyperlocal data you need to power your passions",
  "addons.wundergroundRetrieveApiKey": "Retrieve your API key from this link",
  "addons.wundergroundStationId": "Station ID",
  "airQuality.adviceActivityGood": "A great day to be active outside",
  "airQuality.adviceActivityHazardous": "Avoid all physical activity outdoors",
  "airQuality.adviceActivityLabel": "Physical activity",
  "airQuality.adviceActivityModerate": "A good day to be active outside",
  "airQuality.adviceActivitySensitive": "Consider making outdoor activities shorter and less intense",
  "airQuality.adviceActivityUnhealthy": "Reduce long or intense activities and take more breaks",
  "airQuality.adviceActivityVeryUnhealthy": "Avoid long or intense activities; consider moving them indoors",
  "airQuality.adviceGroupsGood": "No special precautions needed",
  "airQuality.adviceGroupsHazardous": "Remain indoors and keep activity levels low",
  "airQuality.adviceGroupsLabel": "Sensitive groups",
  "airQuality.adviceGroupsModerate": "Unusually sensitive people: make activities shorter and less intense",
  "airQuality.adviceGroupsSensitive": "Make outdoor activities shorter and less intense, and take more breaks",
  "airQuality.adviceGroupsUnhealthy": "Avoid long or intense outdoor activities; consider moving them indoors",
  "airQuality.adviceGroupsVeryUnhealthy": "Avoid all physical activity outdoors; reschedule or move indoors",
  "airQuality.adviceTimingLabel": "When to go out",
  "airQuality.adviceTimingMorning": "Prefer the morning — ozone is lower then",
  "airQuality.airQuality": "Air quality",
  "airQuality.airQualityIndex": "Air quality index",
  "airQuality.aqiForecast": "AQI forecast",
  "airQuality.co2Fresh": "Fresh",
  "airQuality.co2GettingStale": "Slightly stale",
  "airQuality.co2Stale": "Stale",
  "airQuality.dailyForecast": "Daily forecast",
  "airQuality.dominantPollutant": "Dominant pollutant",
  "airQuality.expectedPeak": "Expected peak",
  "airQuality.good": "Good",
  "airQuality.goodDescription": "Air quality is considered satisfactory, and air pollution poses little or no risk",
  "airQuality.hazardous": "Hazardous",
  "airQuality.hazardousDescription": "Health alert: anyone may experience more serious health effects",
  "airQuality.indoorAirQuality": "Indoor air quality",
  "airQuality.moderate": "Moderate",
  "airQuality.moderateDescription": "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution.",
  "airQuality.noForecastForLocation": "No air quality forecast is available for this location.",
  "airQuality.now": "Now",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Pollutants",
  "airQuality.recommendations": "Recommendations",
  "airQuality.sensitiveUnhealthy": "Unhealthy for sensitive groups",
  "airQuality.sensitiveUnhealthyDescription": "Members of sensitive groups may experience health effects. The general public is not likely to be affected.",
  "airQuality.subIndex": "AQI sub-index",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Understanding the index",
  "airQuality.unhealthy": "Unhealthy",
  "airQuality.unhealthyDescription": "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
  "airQuality.veryUnhealthy": "Very unhealthy",
  "airQuality.veryUnhealthyDescription": "Health warnings of emergency conditions. The entire population is more likely to be affected.",
  "alerts.addAlert": "Add alert",
  "alerts.addCondition": "Add condition",
  "alerts.alertAdded": "Alert successfully added",
  "alerts.alertAuthorizationNotice": "Alerts work only if you authorize SmartMixin to display notifications",
  "alerts.alertDeleted": "Alert successfully deleted",
  "alerts.alertName": "Alert name",
  "alerts.alertWhen": "I want to be alerted when:",
  "alerts.aqiGreaterThan": "AQI greater than",
  "alerts.aqiGreaterThanThreshold": "AQI greater than {value}{unit} threshold",
  "alerts.aqiLessThan": "AQI less than",
  "alerts.aqiLessThanThreshold": "AQI less than {value}{unit} threshold",
  "alerts.atLeastOneCondition": "You need to add at least one condition",
  "alerts.co2GreaterThan": "CO2 greater than",
  "alerts.co2GreaterThanThreshold": "CO2 greater than {value}{unit} threshold",
  "alerts.co2LessThan": "CO2 less than",
  "alerts.co2LessThanThreshold": "CO2 less than {value}{unit} threshold",
  "alerts.conditions": "Conditions",
  "alerts.conditionsDroppedOnStationChange": "Not supported by this station and removed: {conditions}",
  "alerts.createAlert": "Create alert",
  "alerts.dailyPrecipitationGreaterThan": "Daily precipitation greater than",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daily precipitation greater than {value}{unit} threshold",
  "alerts.deleteAlert": "Delete alert",
  "alerts.editAlert": "Edit alert",
  "alerts.editCondition": "Edit condition",
  "alerts.gustSpeedGreaterThan": "Gust speed greater than",
  "alerts.gustSpeedGreaterThanThreshold": "Gust speed greater than {value}{unit} threshold",
  "alerts.gustSpeedLessThan": "Gust speed less than",
  "alerts.gustSpeedLessThanThreshold": "Gust speed less than {value}{unit} threshold",
  "alerts.heatIndexGreaterThan": "Heat index greater than",
  "alerts.heatIndexGreaterThanThreshold": "Heat index greater than {value}{unit} threshold",
  "alerts.heatIndexLessThan": "Heat index less than",
  "alerts.heatIndexLessThanThreshold": "Heat index less than {value}{unit} threshold",
  "alerts.humidexGreaterThan": "Humidex greater than",
  "alerts.humidexGreaterThanThreshold": "Humidex greater than {value}{unit} threshold",
  "alerts.humidexLessThan": "Humidex less than",
  "alerts.humidexLessThanThreshold": "Humidex less than {value}{unit} threshold",
  "alerts.humidityGreaterThan": "Humidity greater than",
  "alerts.humidityGreaterThanThreshold": "Humidity greater than {value}{unit} threshold",
  "alerts.humidityLessThan": "Humidity less than",
  "alerts.humidityLessThanThreshold": "Humidity less than {value}{unit} threshold",
  "alerts.inProgress": "In Progress",
  "alerts.leafWetnessGreaterThan": "Leaf wetness greater than",
  "alerts.leafWetnessGreaterThanThreshold": "Leaf wetness greater than {value}{unit} threshold",
  "alerts.leafWetnessLessThan": "Leaf wetness less than",
  "alerts.leafWetnessLessThanThreshold": "Leaf wetness less than {value}{unit} threshold",
  "alerts.myAlerts": "My alerts",
  "alerts.noConfiguredAlert": "You don't have any alerts configured yet, start adding one",
  "alerts.noiseGreaterThan": "Noise greater than",
  "alerts.noiseGreaterThanThreshold": "Noise greater than {value}{unit} threshold",
  "alerts.noiseLessThan": "Noise less than",
  "alerts.noiseLessThanThreshold": "Noise less than {value}{unit} threshold",
  "alerts.noteOnConditions": "Note that the alert is triggered when all of the below conditions are verified",
  "alerts.noTriggerHistory": "This alert hasn't been triggered yet.",
  "alerts.pm10GreaterThan": "PM 10 greater than",
  "alerts.pm10GreaterThanThreshold": "PM 10 greater than {value}{unit} threshold",
  "alerts.pm10LessThan": "PM 10 less than",
  "alerts.pm10LessThanThreshold": "PM 10 less than {value}{unit} threshold",
  "alerts.pm1GreaterThan": "PM 1 greater than",
  "alerts.pm1GreaterThanThreshold": "PM 1 greater than {value}{unit} threshold",
  "alerts.pm1LessThan": "PM 1 less than",
  "alerts.pm1LessThanThreshold": "PM 1 less than {value}{unit} threshold",
  "alerts.pm2p5GreaterThan": "PM 2.5 greater than",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 greater than {value}{unit} threshold",
  "alerts.pm2p5LessThan": "PM 2.5 less than",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 less than {value}{unit} threshold",
  "alerts.postStormSummary": "Post-storm summary",
  "alerts.postStormSynopsisHelper": "You'll get a summary notification after each rain storm ends.",
  "alerts.postStormSynopsisSoleCondition": "A post-storm summary can't be combined with other conditions.",
  "alerts.precipitationGreaterThan": "Hourly precipitation greater than",
  "alerts.precipitationGreaterThanThreshold": "Hourly precipitation greater than {value}{unit} threshold",
  "alerts.pressureGreaterThan": "Pressure greater than",
  "alerts.pressureGreaterThanThreshold": "Pressure greater than {value}{unit} threshold",
  "alerts.pressureLessThan": "Pressure less than",
  "alerts.pressureLessThanThreshold": "Pressure less than {value}{unit} threshold",
  "alerts.rainRateGreaterThan": "Rain rate greater than",
  "alerts.rainRateGreaterThanThreshold": "Rain rate greater than {value}{unit} threshold",
  "alerts.sensorNotReporting": "This sensor isn't reporting right now. The alert resumes when it does.",
  "alerts.soilMoistureGreaterThan": "Soil moisture greater than",
  "alerts.soilMoistureGreaterThanThreshold": "Soil moisture greater than {value}{unit} threshold",
  "alerts.soilMoistureLessThan": "Soil moisture less than",
  "alerts.soilMoistureLessThanThreshold": "Soil moisture less than {value}{unit} threshold",
  "alerts.solarRadiationGreaterThan": "Solar radiation greater than",
  "alerts.solarRadiationGreaterThanThreshold": "Solar radiation greater than {value}{unit} threshold",
  "alerts.solarRadiationLessThan": "Solar radiation less than",
  "alerts.solarRadiationLessThanThreshold": "Solar radiation less than {value}{unit} threshold",
  "alerts.stormChartUnavailable": "Rain history for this storm is unavailable.",
  "alerts.stormDetail": "Storm summary",
  "alerts.stormDuration": "Duration",
  "alerts.stormEnd": "End",
  "alerts.stormPeakRate": "Peak rain rate",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Total rainfall",
  "alerts.temperatureGreaterThan": "Temperature greater than",
  "alerts.temperatureGreaterThanThreshold": "Temperature greater than {value}{unit} threshold",
  "alerts.temperatureLessThan": "Temperature less than",
  "alerts.temperatureLessThanThreshold": "Temperature less than {value}{unit} threshold",
  "alerts.thresholdOutOfRange": "Must be between {min} and {max}",
  "alerts.thswGreaterThan": "THSW greater than",
  "alerts.thswGreaterThanThreshold": "THSW greater than {value}{unit} threshold",
  "alerts.thswLessThan": "THSW less than",
  "alerts.thswLessThanThreshold": "THSW less than {value}{unit} threshold",
  "alerts.thwGreaterThan": "THW greater than",
  "alerts.thwGreaterThanThreshold": "THW greater than {value}{unit} threshold",
  "alerts.thwLessThan": "THW less than",
  "alerts.thwLessThanThreshold": "THW less than {value}{unit} threshold",
  "alerts.triggerHistory": "Alert history",
  "alerts.uvGreaterThan": "UV index greater than",
  "alerts.uvGreaterThanThreshold": "UV index greater than {value}{unit} threshold",
  "alerts.uvLessThan": "UV index less than",
  "alerts.uvLessThanThreshold": "UV index less than {value}{unit} threshold",
  "alerts.visibilityGreaterThanThreshold": "Visibility greater than {value}{unit} threshold",
  "alerts.visibilityLessThanThreshold": "Visibility less than {value}{unit} threshold",
  "alerts.visiblityGreaterThan": "Visibility greater than",
  "alerts.visiblityLessThan": "Visibility less than",
  "alerts.whichMeasure": "Which measure would you like to be alerted for?",
  "alerts.whichModule": "Which module would you like to be alerted for?",
  "alerts.whichSensor": "Which sensor would you like to be alerted for?",
  "alerts.windChillGreaterThan": "Wind chill greater than",
  "alerts.windChillGreaterThanThreshold": "Wind chill greater than {value}{unit} threshold",
  "alerts.windChillLessThan": "Wind chill less than",
  "alerts.windChillLessThanThreshold": "Wind chill less than {value}{unit} threshold",
  "alerts.windSpeedGreaterThan": "Wind speed greater than",
  "alerts.windSpeedGreaterThanThreshold": "Wind speed greater than {value}{unit} threshold",
  "alerts.windSpeedLessThan": "Wind speed less than",
  "alerts.windSpeedLessThanThreshold": "Wind speed less than {value}{unit} threshold",
  "appUpdate.updateAvailable": "Update available",
  "appUpdate.updateAvailableOpenAppStore": "Tap to open the App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Tap to open Google Play",
  "appUpdate.updateAvailableVersion": "Update available: v{version}",
  "appUpdate.upgradeRequiredAndroid": "An upgrade of your application is required. Visit Google Play to upgrade.",
  "appUpdate.upgradeRequiredIos": "An upgrade of your application is required. Visit the App Store to upgrade.",
  "astral.aboveHorizonAllDay": "Above the horizon all day",
  "astral.aboveTheHorizon": "above the horizon",
  "astral.apparentSize": "Apparent size",
  "astral.apparentSizeAcross": "{size} across",
  "astral.astronomicalDawn": "Astronomical dawn",
  "astral.astronomicalDusk": "Astronomical dusk",
  "astral.belowHorizonAllDay": "Below the horizon all day",
  "astral.belowHorizonSince": "Below the horizon since {time}",
  "astral.belowHorizonSinceOn": "Below the horizon since {day} {time}",
  "astral.brightAllNight": "Bright all night — never fully dark",
  "astral.brightestMoment": "Brightest moment",
  "astral.civilDawn": "Civil dawn",
  "astral.civilDusk": "Civil dusk",
  "astral.darkSkyBetween": "Dark sky {from} → {to}",
  "astral.darkSkyWindow": "Dark sky {from} → {to} · {duration} without the moon",
  "astral.dayLength": "Day length",
  "astral.daylightThroughTheYear": "Daylight through the year",
  "astral.dayOfCycle": "day {day} of {total}",
  "astral.doesNotOccurToday": "Does not occur today",
  "astral.domeHint": "Drag to step through the night",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Earliest sunrise",
  "astral.earliestSunset": "Earliest sunset",
  "astral.equinox": "Equinox",
  "astral.equinoxIn": "Equinox in {days, plural, one {# day} other {# days}}",
  "astral.evening": "Evening",
  "astral.exactPhaseAt": "Exact at {time}",
  "astral.firstQuarter": "First quarter",
  "astral.firstSunriseIn": "First sunrise in {days, plural, one {# day} other {# days}}",
  "astral.firstSunsetIn": "First sunset in {days, plural, one {# day} other {# days}}",
  "astral.fullMoon": "Full moon",
  "astral.goldenHourBegins": "Golden hour begins",
  "astral.goldenHourEnds": "Golden hour ends",
  "astral.highestPoint": "Highest point",
  "astral.inDays": "in {days, plural, one {# day} other {# days}}",
  "astral.lastQuarter": "Last quarter",
  "astral.latestSunrise": "Latest sunrise",
  "astral.latestSunset": "Latest sunset",
  "astral.litShort": "Lit",
  "astral.longestDay": "Longest day",
  "astral.lowestPoint": "Lowest point",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Midday",
  "astral.midnightSun": "Midnight sun",
  "astral.midnightSunPeriod": "Midnight sun",
  "astral.milestoneFootnotePolar": "The sun neither rises nor sets on {days, plural, one {# day} other {# days}} of the year here, so in place of the usual sunrise and sunset extremes the list shows when that happens.",
  "astral.milestoneFootnoteTemperate": "The earliest sunset and the latest sunrise do not fall on the shortest day — the equation of time, not the solstice, sets those two dates.",
  "astral.moon": "Moon",
  "astral.moonAltitude": "Altitude",
  "astral.moonDirection": "Azimuth",
  "astral.moonDistance": "Distance",
  "astral.moonlessFor": "{duration} moonless",
  "astral.moonPhases": "Moon phases",
  "astral.moonrise": "Moonrise",
  "astral.moonset": "Moonset",
  "astral.moonUpAllNight": "The moon is up all night",
  "astral.moonWashesOutNight": "The moon is up from {rise} to {set} and washes out the whole night",
  "astral.morning": "Morning",
  "astral.nauticalDawn": "Nautical dawn",
  "astral.nauticalDusk": "Nautical dusk",
  "astral.newMoon": "New moon",
  "astral.nextDay": "+1 day",
  "astral.nextProperlyDarkNight": "Next properly dark night",
  "astral.nextRise": "next rise {time}",
  "astral.nextRiseOn": "next rise {day} {time}",
  "astral.nextSevenNights": "Next seven nights",
  "astral.noAstronomicalDarknessTonight": "No astronomical darkness tonight",
  "astral.noDarkNightAhead": "None in the next two weeks",
  "astral.noSunriseToday": "No sunrise today",
  "astral.nowAtBearing": "now {altitude} · azimuth {direction}",
  "astral.observing": "Observing",
  "astral.ofDaylightLeft": "of daylight left",
  "astral.overTheNextThreeWeeks": "over the next 3 weeks",
  "astral.percentLit": "{percent} lit",
  "astral.polarNight": "Polar night",
  "astral.polarNightPeriod": "Polar night",
  "astral.rightNow": "Right now",
  "astral.riseShort": "Rise",
  "astral.setShort": "Set",
  "astral.shortestDay": "Shortest day",
  "astral.solarNoon": "Solar noon",
  "astral.solstice": "Solstice",
  "astral.sunBelowHorizon": "Sun {degrees}° below the horizon",
  "astral.sunEvents": "Sun events",
  "astral.sunNeverDarkEnough": "The sun never gets 18° below the horizon",
  "astral.sunNeverSets": "Sun never sets",
  "astral.sunrise": "Sunrise",
  "astral.sunriseAndSunset": "Sunrise and sunset",
  "astral.sunriseAt": "Sunrise at {time}",
  "astral.sunset": "Sunset",
  "astral.sunsetAt": "Sunset at {time}",
  "astral.thisYearAtNorth": "This year at {degrees}°N",
  "astral.thisYearAtSouth": "This year at {degrees}°S",
  "astral.tonight": "Tonight",
  "astral.twilightAllNight": "Twilight all night — never fully dark",
  "astral.upFor": "Up for {duration}",
  "astral.usableLight": "Usable light",
  "astral.vsAverage": "{percent} vs average",
  "astral.vsYesterday": "vs yesterday",
  "astral.waningCrescent": "Waning crescent",
  "astral.waningGibbous": "Waning gibbous",
  "astral.waxingCrescent": "Waxing crescent",
  "astral.waxingGibbous": "Waxing gibbous",
  "astral.whereToLook": "Where to look",
  "astral.withoutTheMoon": "{duration} without the moon",
  "auth.alreadyHaveAccount": "Already have an account?",
  "auth.authContainerTagline": "Your personal weather dashboard. Connect your stations and get real-time data at your fingertips.",
  "auth.backToLogin": "Back to login",
  "auth.checkYourEmail": "Check your email",
  "auth.continueWithApple": "Continue with Apple",
  "auth.continueWithFacebook": "Continue with Facebook",
  "auth.continueWithGoogle": "Continue with Google",
  "auth.email": "Email address",
  "auth.emailRequiredLoginFacebook": "Email permission is required.",
  "auth.emailVerification": "Email verification",
  "auth.emailVerificationFailure": "A problem occurred with your email verification.",
  "auth.emailVerificationSuccess": "Your email has been successfully verified.",
  "auth.firstName": "First name",
  "auth.forgotPassword": "Forgot your password?",
  "auth.forgotPasswordSubtitle": "Enter your email and we'll send you a link to reset your password.",
  "auth.lastName": "Last name",
  "auth.login": "Log in",
  "auth.loginSubtitle": "Welcome back! Please enter your details.",
  "auth.loginToSmartMixinDescription": "Sign in to SmartMixin to access your weather stations, view analytics, and manage your personal weather dashboard.",
  "auth.logout": "Log out",
  "auth.logoutConfirmation": "Do you want to log out?",
  "auth.noAccountYet": "Don't have an account?",
  "auth.or": "or",
  "auth.password": "Password",
  "auth.passwordReset": "Password reset",
  "auth.passwordResetSuccess": "Your password has been successfully updated.",
  "auth.register": "Create account",
  "auth.registerDescription": "Create a free SmartMixin account to connect your weather stations, track weather data, and access powerful analytics tools.",
  "auth.registerSubtitle": "Create your account to get started.",
  "auth.restorePassword": "Restore Password",
  "auth.restorePasswordSuccess": "We've just sent you a password reset link at {emailAddress} with further instructions.",
  "auth.sendReset": "Send reset instructions",
  "auth.signInWithApple": "Sign in with Apple",
  "auth.socialAccount": "or use your account",
  "auth.staffVerificationCode": "Verification code",
  "auth.staffVerificationExpiresIn": "Verified. Expires in {duration}.",
  "auth.staffVerificationInvalidCode": "Incorrect code. Try again.",
  "auth.staffVerificationLoginAsStopped": "Login As was stopped: enter a verification code on the Debug screen to continue.",
  "auth.staffVerificationNotEnrolled": "No authenticator app is set up for your account. Add one in the back office security settings.",
  "auth.staffVerificationPrompt": "Enter the 6-digit code from your authenticator app, or a recovery code, to use Login As and user search.",
  "auth.staffVerificationSetupLink": "Add an authenticator app",
  "auth.staffVerificationSubmit": "Verify",
  "auth.staffVerificationTitle": "Staff verification",
  "calendar.afternoon": "Afternoon",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.changePeriod": "Period: {period}. Change period",
  "calendar.currentDay": "Current day",
  "calendar.dateFormat": "Date format",
  "calendar.day": "Day",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} hr",
  "calendar.durationHoursMinutes": "{hours} hr {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.end": "End",
  "calendar.endTime": "End time",
  "calendar.evening": "Evening",
  "calendar.february": "February",
  "calendar.goToNextDay": "Next day",
  "calendar.goToNextMonth": "Next month",
  "calendar.goToNextWeek": "Next week",
  "calendar.goToNextYear": "Next year",
  "calendar.goToPreviousDay": "Previous day",
  "calendar.goToPreviousMonth": "Previous month",
  "calendar.goToPreviousWeek": "Previous week",
  "calendar.goToPreviousYear": "Previous year",
  "calendar.hour": "Hour",
  "calendar.hoursCount": "{count, plural, one {# hour} other {# hours}}",
  "calendar.hoursShort": "hrs",
  "calendar.hoursShortCount": "{count, plural, one {# hr} other {# hrs}}",
  "calendar.january": "January",
  "calendar.july": "July",
  "calendar.june": "June",
  "calendar.last12Hours": "Last 12 hours",
  "calendar.last24Hours": "Last 24 hours",
  "calendar.last30Days": "Last 30 days",
  "calendar.last3Hours": "Last 3 hours",
  "calendar.last6Hours": "Last 6 hours",
  "calendar.last7Days": "Last 7 days",
  "calendar.lastHour": "Last Hour",
  "calendar.march": "March",
  "calendar.max": "Max",
  "calendar.may": "May",
  "calendar.month": "Month",
  "calendar.monthTotal": "Month total",
  "calendar.morning": "Morning",
  "calendar.nextHours": "Next hours",
  "calendar.night": "Night",
  "calendar.november": "November",
  "calendar.october": "October",
  "calendar.oneDay": "1-day",
  "calendar.oneHour": "1-hour",
  "calendar.oneMonth": "1-month",
  "calendar.oneWeek": "1-week",
  "calendar.periodRangeSpoken": "{start} to {end}",
  "calendar.previous24Hours": "Previous 24 hours",
  "calendar.previous30Days": "Previous 30 days",
  "calendar.previous7Days": "Previous 7 days",
  "calendar.previousDay": "Previous day",
  "calendar.previousHours": "Previous hours",
  "calendar.previousMonth": "Previous month",
  "calendar.previousWeek": "Previous week",
  "calendar.previousYear": "Previous year",
  "calendar.sameDayLastYear": "Same day last year",
  "calendar.sameMonthLastYear": "Same month last year",
  "calendar.selectADate": "Select a date",
  "calendar.selectAggregation": "Select displayed value",
  "calendar.selectAMonth": "Select a month",
  "calendar.selectAYear": "Select a year",
  "calendar.selectGranularity": "Select a granularity",
  "calendar.selectPeriod": "Select a period",
  "calendar.september": "September",
  "calendar.sixHours": "6-hour",
  "calendar.start": "Start",
  "calendar.startTime": "Start time",
  "calendar.thirtyMinutes": "30-min",
  "calendar.threeHours": "3-hour",
  "calendar.timezone": "Timezone",
  "calendar.today": "Today",
  "calendar.untilChanged": "Until changed",
  "calendar.untilTime": "Until {time}",
  "calendar.untilTodayAt": "Until today at {time}",
  "calendar.untilTomorrowAt": "Until tomorrow at {time}",
  "calendar.use24HourFormat": "Use 24-hour format",
  "calendar.week": "Week",
  "calendar.year": "Year",
  "calendar.yearToDate": "Year to Date",
  "calendar.yesterday": "Yesterday",
  "charts.averageOverThePeriod": "Average over the period",
  "charts.calendarView": "Calendar view",
  "charts.charts": "Charts",
  "charts.chartView": "Chart view",
  "charts.comparison": "Comparison",
  "charts.customizeComparisonMetrics": "Customize metrics",
  "charts.customizeComparisonMetricsDescription": "Drag items to reorder your comparison metrics. Tap the eye icon to show or hide metrics.",
  "charts.maxOverThePeriod": "Maximum over the period",
  "charts.measureToDisplay": "Measure to display",
  "charts.minMaxRange": "Min / Max",
  "charts.noDataForThisPeriod": "No data for this period",
  "charts.observations": "Observations",
  "charts.observedTemperature": "Observed temperature",
  "charts.showComparison": "Show comparison",
  "charts.stationComparison": "Station comparison",
  "charts.stationComparisonDescription": "Compare historical weather data with another station",
  "charts.sumOverThePeriod": "Cumulated over the period",
  "charts.viewAsList": "List",
  "charts.viewAsPeriods": "Periods",
  "common.add": "Add",
  "common.altitude": "Altitude",
  "common.analysis": "Analysis",
  "common.average": "Average",
  "common.back": "Back",
  "common.backToHome": "Back to Home",
  "common.cancel": "Cancel",
  "common.cannotBeEmpty": "This field cannot be empty.",
  "common.close": "Close",
  "common.dailyForecast": "Daily forecast",
  "common.default": "Default",
  "common.delete": "Delete",
  "common.details": "Details",
  "common.edit": "Edit",
  "common.exitFullscreen": "Exit fullscreen",
  "common.forecast": "Forecast",
  "common.frequency": "Frequency",
  "common.full": "Full",
  "common.fullscreen": "Fullscreen",
  "common.help": "Help",
  "common.hidden": "Hidden",
  "common.high": "High",
  "common.iDontKnowYet": "I don't know yet",
  "common.indoor": "Indoor",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Last update",
  "common.low": "Low",
  "common.maximum": "Maximum",
  "common.medium": "Medium",
  "common.minimum": "Minimum",
  "common.more": "More",
  "common.moreInformation": "More information",
  "common.next": "Next",
  "common.no": "No",
  "common.noAccountNeeded": "No account needed",
  "common.noItemsAvailable": "No items available",
  "common.notNow": "Not Now",
  "common.now": "Now",
  "common.numberOfActiveWarnings": "{warning_count, plural, one {# active weather warning} other {# active weather warnings}}",
  "common.openSettings": "Open Settings",
  "common.outdoor": "Outdoor",
  "common.pageNotFound": "Page Not Found",
  "common.pageNotFoundDescription": "The page you're looking for doesn't exist or has been moved.",
  "common.rain": "Rain",
  "common.share": "Share",
  "common.shareImageFailed": "Couldn't share the image",
  "common.shareYourWeather": "Share your weather",
  "common.skip": "Skip",
  "common.start": "Start",
  "common.unknown": "Unknown",
  "common.validate": "Confirm",
  "common.validEmail": "A valid email address is required.",
  "common.very_low": "Very low",
  "common.weatherObservations": "Weather observations",
  "common.welcome": "Welcome to SmartMixin!",
  "common.wind": "Wind",
  "common.yes": "Yes",
  "common.zoomImage": "Zoom image",
  "compass.E": "E",
  "compass.E_long": "East",
  "compass.ENE": "ENE",
  "compass.ENE_long": "East-Northeast",
  "compass.ESE": "ESE",
  "compass.ESE_long": "East-Southeast",
  "compass.N": "N",
  "compass.N_long": "North",
  "compass.NE": "NE",
  "compass.NE_long": "Northeast",
  "compass.NNE": "NNE",
  "compass.NNE_long": "North-Northeast",
  "compass.NNW": "NNW",
  "compass.NNW_long": "North-Northwest",
  "compass.NW": "NW",
  "compass.NW_long": "Northwest",
  "compass.S": "S",
  "compass.S_long": "South",
  "compass.SE": "SE",
  "compass.SE_long": "Southeast",
  "compass.SSE": "SSE",
  "compass.SSE_long": "South-Southeast",
  "compass.SSW": "SSW",
  "compass.SSW_long": "South-Southwest",
  "compass.SW": "SW",
  "compass.SW_long": "Southwest",
  "compass.W": "W",
  "compass.W_long": "West",
  "compass.WNW": "WNW",
  "compass.WNW_long": "West-Northwest",
  "compass.WSW": "WSW",
  "compass.WSW_long": "West-Southwest",
  "dashboard.currentObservations": "Current observations",
  "dashboard.currentRainEvent": "Current rain event",
  "dashboard.currentWeatherConditions": "Current conditions",
  "dashboard.customizeDashboard": "Customize",
  "dashboard.customizeDashboardDescription": "Drag items to reorder your dashboard. Tap the eye icon to show or hide sections.",
  "dashboard.dashboard": "Dashboard",
  "dashboard.dayRangeExpected": "{value} expected {time}",
  "dashboard.dayRangeReached": "{value} at {time}",
  "dashboard.dayRangeSteady": "Steady {value} all day",
  "dashboard.hiddenSensors": "Hidden sensors",
  "dashboard.lastRainEvent": "Last rain event",
  "dashboard.manageSensors": "Manage sensors",
  "dashboard.manageSensorsDescription": "Drag items to reorder sensors. Tap the eye icon to show or hide sensors. Tap a name to rename it.",
  "dashboard.pressureSummary": "Pressure summary",
  "dashboard.rainEvents": "Rain events",
  "dashboard.rainSummary": "Rain summary",
  "dashboard.shareOutdoorMeasures": "Share your outdoor measures",
  "dashboard.shareOutdoorMeasuresDescription": "Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared.",
  "dashboard.temperatureSummary": "Temperature summary",
  "dashboard.windSummary": "Wind summary",
  "devices.batteryLevel": "Battery level",
  "devices.firmwareVersion": "Firmware version",
  "devices.moduleCount": "{count, plural, one {# module} other {# modules}}",
  "devices.moduleType": "Module type",
  "devices.noNetatmoWeatherStationYet": "You don't have a Netatmo weather station yet.",
  "devices.noOutdoorModule": "There is no functional outdoor module for this station.",
  "devices.notReachable": "Not reachable",
  "devices.serialNumber": "Serial number",
  "devices.signalAverage": "Fair",
  "devices.signalBad": "Poor",
  "devices.signalGood": "Good",
  "devices.signalStrength": "Signal strength",
  "devices.signalUnknown": "Unknown",
  "devices.visitNetatmoWebsite": "Visit Netatmo website",
  "devices.wifiStrength": "Wi-Fi strength",
  "forecastMaps.addColor": "Add color",
  "forecastMaps.addLayer": "Add layer",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Back to maps",
  "forecastMaps.build": "Build",
  "forecastMaps.buildCompleted": "Build completed",
  "forecastMaps.builderMetaDescription": "Compose custom forecast maps from weather model layers.",
  "forecastMaps.builderTitle": "Map builder",
  "forecastMaps.buildFailed": "The build failed. Please try again.",
  "forecastMaps.buildNotPossible": "This map cannot be built yet — no forecast data is available.",
  "forecastMaps.buildProgress": "Rendering… {completed}/{total} steps",
  "forecastMaps.buildStarting": "Starting build…",
  "forecastMaps.byModel": "By model",
  "forecastMaps.byZone": "By zone",
  "forecastMaps.colormap": "Colormap",
  "forecastMaps.colormapCustom": "Custom colors",
  "forecastMaps.colormapGroupDomain": "Weather presets",
  "forecastMaps.colormapGroupMatplotlib": "Scientific presets",
  "forecastMaps.colorScale": "Color scale",
  "forecastMaps.contourLevels": "Contour levels",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "France",
  "forecastMaps.countryGermany": "Germany",
  "forecastMaps.countryItaly": "Italy",
  "forecastMaps.countryScandinavia": "Scandinavia",
  "forecastMaps.countrySpain": "Spain",
  "forecastMaps.countrySwitzerland": "Switzerland",
  "forecastMaps.countryUnitedStates": "United States",
  "forecastMaps.customColormapMinColors": "A custom colormap needs at least two colors",
  "forecastMaps.customExtent": "Custom extent",
  "forecastMaps.displayName": "Display name",
  "forecastMaps.downscaling": "Barb thinning factor",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Draw area",
  "forecastMaps.east": "East",
  "forecastMaps.extentDrawHint": "Drag on the map to draw the area",
  "forecastMaps.extentInvalid": "West must be less than east and south less than north",
  "forecastMaps.height": "Height (inches)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Invalid color — use #RRGGBB",
  "forecastMaps.layers": "Layers",
  "forecastMaps.layerTypeBarbs": "Wind barbs",
  "forecastMaps.layerTypeContour": "Contour lines",
  "forecastMaps.layerTypeFilledContour": "Filled contours",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vector field",
  "forecastMaps.leave": "Leave",
  "forecastMaps.levelsCount": "Count",
  "forecastMaps.levelsInvalid": "Invalid contour levels",
  "forecastMaps.levelsModeArange": "Fixed step",
  "forecastMaps.levelsModeExplicit": "Explicit values",
  "forecastMaps.levelsModeLinspace": "Evenly spaced (count)",
  "forecastMaps.levelsStep": "Step",
  "forecastMaps.levelsValues": "Values",
  "forecastMaps.levelsValuesHint": "Comma-separated, ascending",
  "forecastMaps.localTimeHint": "Shown in your local time",
  "forecastMaps.mapDescription": "Description",
  "forecastMaps.mapName": "Map name",
  "forecastMaps.mapNameRequired": "Enter a name",
  "forecastMaps.mapSettings": "Map settings",
  "forecastMaps.mapView": "Interactive map",
  "forecastMaps.maxLayersReached": "This map has reached the maximum of {max} layers.",
  "forecastMaps.maxValue": "Max value",
  "forecastMaps.memoryBudgetExceeded": "The resolution exceeds the render budget — reduce DPI or height",
  "forecastMaps.memoryBudgetUsage": "Render budget: {percent}%",
  "forecastMaps.metaDescription": "Animated forecast maps rendered from weather model runs.",
  "forecastMaps.metric": "Metric",
  "forecastMaps.metricRequired": "Select a metric",
  "forecastMaps.metricUnavailable": "Not available for this model",
  "forecastMaps.minBelowMax": "Min must be less than max",
  "forecastMaps.minMaxRequired": "Min and max values are required for this layer type",
  "forecastMaps.minValue": "Min value",
  "forecastMaps.modelNoRun": "No completed run yet",
  "forecastMaps.moveLayerDown": "Move down",
  "forecastMaps.moveLayerUp": "Move up",
  "forecastMaps.myMaps": "My maps",
  "forecastMaps.nanClipToMin": "Clip to min",
  "forecastMaps.nanMask": "Mask",
  "forecastMaps.nanPolicy": "Missing data",
  "forecastMaps.nanSkip": "Skip",
  "forecastMaps.noCompletedRun": "This map has not been rendered yet. Please check back soon.",
  "forecastMaps.noLayers": "No layers yet. Add a layer to get started.",
  "forecastMaps.noMapsAvailable": "No forecast maps are available yet.",
  "forecastMaps.north": "North",
  "forecastMaps.opacity": "Opacity",
  "forecastMaps.overlayLegend": "Legend",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Play",
  "forecastMaps.pointValueError": "Could not load the forecast for this point.",
  "forecastMaps.pointValueLoading": "Loading forecast…",
  "forecastMaps.pointValueUnavailable": "No data for this time.",
  "forecastMaps.presets": "Presets",
  "forecastMaps.preview": "Preview",
  "forecastMaps.previewEmptyHint": "Configure at least one valid layer to render a preview.",
  "forecastMaps.previewFailed": "The preview failed",
  "forecastMaps.previewHour": "Forecast hour",
  "forecastMaps.previewRendering": "Rendering preview…",
  "forecastMaps.projection": "Projection",
  "forecastMaps.projectionLambertConformal": "Lambert conformal",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereographic",
  "forecastMaps.regionEurope": "Europe",
  "forecastMaps.regionNorthAmerica": "North America",
  "forecastMaps.removeColor": "Remove color",
  "forecastMaps.removeLayer": "Remove layer",
  "forecastMaps.retry": "Retry",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.save": "Save",
  "forecastMaps.selectExtentOnMap": "Select area on map",
  "forecastMaps.south": "South",
  "forecastMaps.title": "Forecast maps",
  "forecastMaps.uMetric": "U component",
  "forecastMaps.unitConversion": "Unit conversion",
  "forecastMaps.unitNone": "None",
  "forecastMaps.unsavedChangesBody": "You have unsaved changes. Leave and discard them?",
  "forecastMaps.unsavedChangesTitle": "Unsaved changes",
  "forecastMaps.useCurrentView": "Use current view",
  "forecastMaps.useModelDomain": "Off: the full model domain is used",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U and V metrics must differ",
  "forecastMaps.valueBetween": "Must be between {min} and {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.viewMap": "View map",
  "forecastMaps.vMetric": "V component",
  "forecastMaps.west": "West",
  "forecastMaps.windAnimation": "Wind animation",
  "forecastModels.addForecastModel": "Add a model",
  "forecastModels.atYourStations": "Available at your stations",
  "forecastModels.coverageLoading": "Working out which of your stations each model covers…",
  "forecastModels.description_AROME": "Météo France's high-resolution convection-allowing model over Western Europe at 1.3 km resolution. Best-in-class for short-term forecasts in France; refreshed every three hours.",
  "forecastModels.description_ARPEGE_EU": "Météo France's European nest of the ARPEGE model at 10 km resolution. Mid-range forecasts over Europe, refreshed four times daily.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo France's global numerical weather model at 25 km resolution, running to about 4 days. Refreshed four times daily.",
  "forecastModels.description_DMI_DINI": "DMI's HARMONIE DINI: a convection-allowing model over northwest Europe — Denmark, the Benelux, Ireland, the UK and Scandinavia — at 2 km resolution out to 60 hours, refreshed eight times daily. Contains modified DMI open data (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canada's Global Deterministic Prediction System: a worldwide medium-range model at 15 km resolution running out to 10 days, updated twice daily.",
  "forecastModels.description_EC_HRDPS": "Environment Canada's High Resolution Deterministic Prediction System: a convection-allowing model over Canada and the northern United States at 2.5 km resolution out to 48 hours, refreshed four times daily.",
  "forecastModels.description_EC_RDPS": "Environment Canada's Regional Deterministic Prediction System: a mid-range model over North America at 10 km resolution, refreshed four times daily.",
  "forecastModels.description_ECMWF_HRES": "The European Centre for Medium-Range Weather Forecasts' flagship high-resolution model (IFS), widely regarded as the world's leading global forecast system. Covers the entire planet at 25 km resolution out to 15 days, updated four times daily. Contains modified ECMWF open data (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAA's flagship medium-range global model. Covers the entire planet at 25 km resolution out to 16 days, updated four times per day.",
  "forecastModels.description_HRRR_CONUS": "NOAA's High-Resolution Rapid Refresh: a convection-allowing model over the continental United States at 3 km resolution, refreshed every hour. Best suited for very short-term forecasts of thunderstorms and severe weather.",
  "forecastModels.description_ICON": "DWD's global ICON model at 13 km resolution covering the entire planet out to 7.5 days, refreshed four times daily. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteo's ICON-2I, run jointly with ARPAE: a convection-allowing model over Italy at 2.2 km resolution out to 72 hours, refreshed twice daily. Contains ItaliaMeteo open data (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "MeteoSwiss's ICON-CH1-EPS control run: a convection-allowing model over the Alps at 1 km resolution out to 33 hours, refreshed every three hours.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss's ICON-CH2-EPS control run: a convection-allowing model over the Alps — Switzerland and the surrounding Alpine region — at 2.1 km resolution out to 120 hours, refreshed four times daily.",
  "forecastModels.description_ICON_DE": "DWD's high-resolution convection-allowing model over Germany and surrounding countries at 2.2 km resolution. Short-term forecasts refreshed twice daily. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWD's European nest of the ICON model at 7 km resolution covering Europe and the North Atlantic. Mid-range forecasts refreshed four times daily. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "The Norwegian Meteorological Institute's open weather forecast service, blending high-resolution Nordic models with ECMWF data to provide worldwide forecasts up to 10 days ahead.",
  "forecastModels.description_MF_AROME_ANTILLES": "AROME nest over the French Antilles (Guadeloupe, Martinique) at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "forecastModels.description_MF_AROME_GUYANE": "AROME nest over French Guiana at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "AROME nest over New Caledonia at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "forecastModels.description_MF_AROME_POLYNESIE": "AROME nest over French Polynesia at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "AROME nest over Réunion and Mayotte at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "forecastModels.description_RRFS_CONUS": "NOAA's Rapid Refresh Forecast System over the continental United States at 3 km resolution. Hourly forecasts refreshed eight times daily, reaching 84 hours on the four main runs and 18 hours on the others.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA's Rapid Refresh Forecast System covering all of North America at 13 km resolution. Hourly forecasts to 84 hours, refreshed four times daily.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixin's flagship forecast. For every hour at your location, we pick the best model available — typically a high-resolution regional model where one exists (AROME in France, ICON-D2 in Germany, HRRR in the United States, ARPEGE Europe across the continent…) and fall back to a global model elsewhere — then fill any gaps from neighbouring sources. The result is a single, seamless forecast covering anywhere in the world out to 14 days, refreshed automatically whenever any of the underlying models is updated.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflow's proprietary global forecast that blends multiple numerical weather models with observations from its Tempest weather station network. 10-day worldwide horizon.",
  "forecastModels.everywhereElse": "Everywhere else",
  "forecastModels.everywhereElseFoot": "Used at any station your preferred models do not reach.",
  "forecastModels.everywhereElsePick": "Pick one",
  "forecastModels.fallbackBlend": "SmartMixin blend",
  "forecastModels.fallbackBlendSub": "Combines several models, each where it is strongest.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES wherever it reaches.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA's global model. What every account uses today.",
  "forecastModels.fallbackResolution": "Highest resolution",
  "forecastModels.fallbackResolutionSub": "The finest mesh available at each station.",
  "forecastModels.forecastChipLabelWithRun": "{model}, run {run}",
  "forecastModels.forecastChipRunHint": "Long press to show or hide the latest run",
  "forecastModels.forecastComparisonDescription": "Easily compare forecast model outputs from several sources",
  "forecastModels.forecastFollowingPreferences": "Following your preferences",
  "forecastModels.forecastModel": "Forecast model",
  "forecastModels.forecastModelComparison": "Forecast model comparison",
  "forecastModels.forecastModelCoverage": "Coverage",
  "forecastModels.forecastModelDescription": "Description",
  "forecastModels.forecastModels": "Forecast models",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "This model covers the entire planet.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "This model only covers a specific region.",
  "forecastModels.forecastModelSpecifications": "Specifications",
  "forecastModels.forecastNoPinLocation": "No preferred model reaches this location — \"everywhere else\" decides.",
  "forecastModels.forecastNoPinStation": "No preferred model reaches this station — \"everywhere else\" decides.",
  "forecastModels.forecastNoPreferredModels": "No preferred models set yet.",
  "forecastModels.forecastOverrideElsewhere": "Your preferences apply everywhere else.",
  "forecastModels.forecastPickForLocation": "Or pick one for this location",
  "forecastModels.forecastPickForStation": "Or pick one for this station",
  "forecastModels.forecastPinWinsLocation": "{model} — your first preferred model that reaches this location.",
  "forecastModels.forecastPinWinsStation": "{model} — your first preferred model that reaches this station.",
  "forecastModels.forecastServedNowHere": "Right now that is {model} here",
  "forecastModels.forecastSetForLocation": "Set for this location",
  "forecastModels.forecastSetForStation": "Set for this station",
  "forecastModels.forecastSettingsRowSub": "Preferred models, and what applies everywhere else",
  "forecastModels.forecastStopUsingHere": "Stop using here",
  "forecastModels.forecastUseForLocation": "Use {model} for this location",
  "forecastModels.forecastUseForStation": "Use {model} for this station",
  "forecastModels.forecastUsePreferred": "Use my preferred models",
  "forecastModels.frequencyHourly": "Every hour",
  "forecastModels.horizon": "Horizon",
  "forecastModels.horizonValue": "up to {value} hours",
  "forecastModels.meshSize": "Grid size",
  "forecastModels.pickerShowAll": "Show the full catalogue",
  "forecastModels.pickerUnreachable": "{count, plural, one {# more model does} other {# more models do}} not reach any of your stations",
  "forecastModels.pinInUse": "In use",
  "forecastModels.pinShadowed": "Never used — a model above covers all your stations",
  "forecastModels.pinSlots": "{used} of {max} · choose a model",
  "forecastModels.pinSlotsFull": "{max, plural, one {All # slot used. Remove its model to add another.} other {All # slots used. Remove one to add another.}}",
  "forecastModels.pinsUncoveredCount": "{used} of your {count, plural, one {# station} other {# stations}}: no preferred model reaches {used, plural, one {it} other {them}} — \"everywhere else\" decides.",
  "forecastModels.pinsUncoveredNamed": "{stations}: no preferred model reaches {count, plural, one {it} other {them}} — \"everywhere else\" decides.",
  "forecastModels.pinUnreachable": "Never used — it reaches none of your stations",
  "forecastModels.pinUsedAt": "Used at {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Used at your station} other {Used at all # stations}}",
  "forecastModels.pinUsedAtSome": "Used at {used} of {count, plural, one {# station} other {# stations}}",
  "forecastModels.preferredModels": "Preferred models",
  "forecastModels.preferredModelsAll": "One list, all stations",
  "forecastModels.preferredModelsOne": "One list, applies everywhere",
  "forecastModels.publisher": "Publisher",
  "forecastModels.removePreferredModel": "Remove {model} from your preferred models",
  "forecastModels.resetForecastPreference": "Reset to default",
  "forecastModels.resetForecastPreferenceHint": "Clears your preferred models and goes back to the SmartMixin default.",
  "forecastModels.servedNowMany": "Right now: GFS at {count, plural, one {your station} other {all # stations}}.",
  "forecastModels.servedNowNone": "Right now: GFS wherever you look.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multi-model",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow Forecast",
  "forecastModels.weatherForecastModels": "Weather forecast models",
  "helpCenter.articleCount": "{count, plural, one {# article} other {# articles}}",
  "helpCenter.articleNotFound": "Article Not Found",
  "helpCenter.articleNotFoundDescription": "The article you're looking for doesn't exist.",
  "helpCenter.backToHelpCenter": "Back to Help Center",
  "helpCenter.browseByCategory": "Browse by Category",
  "helpCenter.categoryNotFound": "Category not found",
  "helpCenter.categoryNotFoundDescription": "This category doesn't exist or has no articles.",
  "helpCenter.contactSupport": "Contact support",
  "helpCenter.feedbackHelpsImprove": "Your input helps us improve our help articles.",
  "helpCenter.feedbackReasonNotAnswer": "It doesn't answer my question",
  "helpCenter.feedbackReasonOutdated": "The information is outdated",
  "helpCenter.feedbackReasonUnclear": "The instructions are unclear",
  "helpCenter.feedbackWhatWentWrong": "What was the problem?",
  "helpCenter.helpCategoryAccount": "Account",
  "helpCenter.helpCategoryBilling": "Billing",
  "helpCenter.helpCategoryForecast": "Forecasts",
  "helpCenter.helpCategoryGettingStarted": "Getting Started",
  "helpCenter.helpCategoryProviders": "Providers",
  "helpCenter.helpCategoryStations": "Stations",
  "helpCenter.helpCategoryTroubleshooting": "Troubleshooting",
  "helpCenter.helpCenter": "Help Center",
  "helpCenter.landingDescription": "Find answers to common questions and learn how to get the most out of SmartMixin.",
  "helpCenter.linkToSection": "Link to this section",
  "helpCenter.menuItemDescription": "FAQs and guides",
  "helpCenter.minRead": "{minutes} min read",
  "helpCenter.onThisPage": "On this page",
  "helpCenter.platformMobileApp": "Mobile app",
  "helpCenter.platformMobileOnly": "Mobile app only",
  "helpCenter.platformWebApp": "Web app",
  "helpCenter.platformWebOnly": "Web app only",
  "helpCenter.popularArticles": "Popular articles",
  "helpCenter.relatedArticles": "Related Articles",
  "helpCenter.searchArticles": "Search articles...",
  "helpCenter.stillNeedHelp": "Still need help?",
  "helpCenter.stillNeedHelpDescription": "If this article didn't answer your question, I'm happy to help you directly.",
  "helpCenter.supportEmailSubject": "SmartMixin Help",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin Help — {topic}",
  "helpCenter.thankYouForFeedback": "Thank you for your feedback!",
  "helpCenter.wasArticleHelpful": "Was this article helpful?",
  "intro.locationDescription": "Enable location access to get accurate weather predictions tailored to your exact area — no more one-size-fits-all forecasts.",
  "intro.locationTitle": "Forecasts Made for You",
  "intro.notificationDescription": "Turn on notifications to get timely alerts about weather changes that matter to you — rain, snow, or severe conditions, right when you need to know.",
  "intro.notificationsTitle": "Never Miss a Weather Shift",
  "intro.readyDescription": "Enjoy precise forecasts, real-time weather insights, and station data from around the globe — all in one powerful app.",
  "intro.readyTitle": "You're All Set!",
  "intro.welcomeDescription": "Get hyperlocal forecasts powered by top weather agencies — plus access to 40,000+ weather stations worldwide to see real-world conditions, past and present.",
  "intro.welcomeTitle": "Your Weather, Reimagined",
  "landing.alsoAvailableOn": "Also available on:",
  "landing.featureAlertsDescription": "Set custom thresholds for any metric. Get notified when temperature drops, rain starts, or wind picks up.",
  "landing.featureAlertsTitle": "Smart Alerts",
  "landing.featureAnalyticsDescription": "Interactive charts, trend analysis, and detailed statistics. Dive deep into temperature, humidity, pressure, rain, and wind data.",
  "landing.featureAnalyticsTitle": "Advanced Analytics",
  "landing.featureExportDescription": "Get all your weather data by email as an Excel spreadsheet, ready for further analysis in Excel, Google Sheets, or your favorite tools.",
  "landing.featureExportTitle": "Export Your Data",
  "landing.featureForecastDescription": "Access {count, plural, one {#+ professional forecast model} other {#+ professional forecast models}} including ECMWF, GFS, and regional models. Compare them side-by-side to make your own predictions.",
  "landing.featureForecastTitle": "Compare Forecast Models",
  "landing.featureHistoryDescription": "Access historical data with hourly, daily, and monthly scales. Export it to Excel for research or personal archives.",
  "landing.featureHistoryTitle": "Rich History",
  "landing.featureMultiBrandDescription": "Connect Netatmo, Davis, Tempest, Ecowitt, Ambient Weather, and more. No more switching between apps.",
  "landing.featureMultiBrandTitle": "All Brands, One App",
  "landing.featuresSubtitle": "SmartMixin gives you the tools to analyze, compare, and understand your weather data like a pro.",
  "landing.featuresTitle": "Built for data lovers",
  "landing.finalCtaButton": "Create Free Account",
  "landing.finalCtaSubtitle": "Join thousands of weather enthusiasts who trust SmartMixin.",
  "landing.finalCtaTitle": "Ready to dive deeper into your weather data?",
  "landing.heroCta": "Start Free",
  "landing.heroDescription": "Deep analytics, beautiful charts, and professional forecasts — all your weather stations unified in one powerful app.",
  "landing.heroSecondaryCta": "Explore the Map",
  "landing.heroTagline": "For Weather Enthusiasts",
  "landing.heroTitle": "See your weather like never before",
  "landing.pricingFeatureAdvancedMetrics": "Advanced metrics",
  "landing.pricingFeatureAlerts": "Custom alerts",
  "landing.pricingFeatureExport": "Data export (Excel)",
  "landing.pricingFeatureForecastComparison": "Forecast comparison",
  "landing.pricingFeatureForecasts": "Forecast models",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} other {#+ models}}",
  "landing.pricingFeatureReports": "Analysis & reports",
  "landing.pricingFeatureStationComparison": "Station comparison",
  "landing.pricingFeatureWidgets": "Home screen widgets",
  "landing.pricingFeatureYearOverYear": "Year-over-year analysis",
  "landing.pricingFreeCta": "Get Started",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Most Popular",
  "landing.pricingPremiumCta": "Get Started",
  "landing.pricingPremiumDescription": "From 1.99 €/month — subscribe on web, App Store, or Google Play",
  "landing.pricingSubtitle": "Start free, upgrade when you need more power.",
  "landing.pricingTitle": "Simple, transparent pricing",
  "landing.statBrands": "Brands supported",
  "landing.statForecasts": "Forecast models",
  "landing.statStations": "Weather stations",
  "landing.supportedDevicesNote": "Plus more than {count, number} public stations from the World Meteorological Organization network",
  "landing.supportedDevicesSubtitle": "Connect your existing weather station in minutes. We support {count, plural, one {# major brand} other {# major brands}} and growing.",
  "landing.supportedDevicesTitle": "Works with your station",
  "metrics.absolutePressure": "Absolute pressure",
  "metrics.airDensity": "Air density",
  "metrics.airGap": "Air gap",
  "metrics.apparentTemperature": "Apparent temperature",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Avg.",
  "metrics.avg_wind": "Mean wind",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Black globe temp.",
  "metrics.boilerOn": "Boiler ON",
  "metrics.boilerOnInHours": "Boiler ON (hours)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Conductivity",
  "metrics.dailyPrecipitation": "Daily precipitation",
  "metrics.dailyRain": "Daily rain",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Depth",
  "metrics.depthSensors": "Depth sensors",
  "metrics.dewPoint": "Dew point",
  "metrics.distance": "Distance",
  "metrics.downTrend": "down",
  "metrics.ET": "Evapotranspiration",
  "metrics.etToday": "ET today",
  "metrics.feelsLike": "Feels like",
  "metrics.feelsLikeWithFormula": "Feels like ({formula})",
  "metrics.frostPoint": "Frost point",
  "metrics.gust": "Gust",
  "metrics.hail": "Hail",
  "metrics.heatIndex": "Heat index",
  "metrics.heatingDegreeDays": "Heating degree days",
  "metrics.heatingPower": "Heating power",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Humidity",
  "metrics.lastLightningImpact": "Last impact",
  "metrics.lastMeasure": "Last measure",
  "metrics.leafSensors": "Leaf sensors",
  "metrics.leafWetness": "Leaf wetness",
  "metrics.lightningDistance": "Distance",
  "metrics.lightningStrikeCount": "Lightning strike count",
  "metrics.lightningStrikeDistance": "Lightning strike distance",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. gust",
  "metrics.maxToday": "Max today",
  "metrics.min": "Min.",
  "metrics.noise": "Noise",
  "metrics.normalizedHeatingCoefficient": "Normalized heating coefficient",
  "metrics.outdoorTemperature": "Outdoor temperature",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Precipitation",
  "metrics.pressure": "Pressure",
  "metrics.rain": "Rain",
  "metrics.rainDurationValue": "Rain duration: {duration}",
  "metrics.rainfallMeasurement": "Rainfall measurement",
  "metrics.rainRate": "Rain rate",
  "metrics.relativePressure": "Relative pressure",
  "metrics.setPoint": "Setpoint",
  "metrics.snow": "Snow",
  "metrics.snowfall": "Snowfall",
  "metrics.soilMoisture": "Moisture",
  "metrics.soilSensors": "Soil sensors",
  "metrics.soilWaterTension": "Soil water tension",
  "metrics.solarEnergy": "Solar energy",
  "metrics.solarRadiation": "Solar radiation",
  "metrics.speed": "Speed",
  "metrics.stableTrend": "stable",
  "metrics.sum": "Sum",
  "metrics.temperature": "Temperature",
  "metrics.temperatureSensors": "Temperature & humidity sensors",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "up",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibility",
  "metrics.weatherCondition": "Weather condition",
  "metrics.wetBulbGlobeTemperature": "Wet bulb globe temp.",
  "metrics.wetBulbTemperature": "Wet bulb temp.",
  "metrics.wind": "Wind",
  "metrics.windChill": "Wind chill",
  "metrics.windDirection": "Wind direction",
  "metrics.windMeasurement": "Wind measurement",
  "metrics.windRun": "Wind run",
  "metrics.windRunDescription": "Wind run is the total distance the wind travels over a period of time",
  "metrics.windSpeed": "Wind speed",
  "network.cancelError": "Request has been cancelled",
  "network.connectionError": "Server not available",
  "network.networkError": "Network not available",
  "network.serverError": "Something went wrong...",
  "network.timeoutError": "Connection timeout",
  "network.unknownError": "Unknown Error",
  "premium.alreadyPremium": "You already have a premium account!",
  "premium.bestValue": "Best Value",
  "premium.billingDetailsAndroid": "Free trial: you will not be charged if you cancel at least 24 hours before the trial ends. After that, your SmartMixin subscription renews automatically unless you cancel it at least 24 hours before the end of the current period; you can cancel at any time in your Google Play account settings. Each renewal is charged at the price shown on the button above. Payment is charged to your Google Play account when you confirm your purchase and at the start of each renewal period.",
  "premium.billingDetailsIos": "Free trial: you will not be charged if you cancel at least 24 hours before the trial ends. After that, your SmartMixin subscription renews automatically unless you cancel it at least 24 hours before the end of the current period; you can cancel at any time in your App Store account settings. Each renewal is charged at the price shown on the button above. Payment is charged to your App Store account when you confirm your purchase and at the start of each renewal period.",
  "premium.freeBannerBody": "Free accounts are served GFS everywhere — your preferred models and \"everywhere else\" both start working the moment you subscribe.",
  "premium.freeBannerTitle": "Preferences apply with Premium",
  "premium.freeSubscription": "Free premium subscription",
  "premium.freeTrialForPeriod": "Free trial for {period, plural, one {# day} other {# days}}",
  "premium.getUnlimitedAccess": "Get unlimited access to:",
  "premium.manageMySubscription": "Manage my subscription",
  "premium.notPurchasedYet": "No SmartMixin Premium purchase was found for this store account.",
  "premium.orChooseMonthly": "Or choose monthly:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Active",
  "premium.premiumAnnualTrialInfo": "Start with a free trial of {days, plural, one {# day} other {# days}}",
  "premium.premiumCurrentPlan": "Current Plan",
  "premium.premiumDownloadApp": "Download the app to subscribe:",
  "premium.premiumEndsOn": "Expires on {date}",
  "premium.premiumFeatureAlerts": "Weather Alerts",
  "premium.premiumFeatureAnalysis": "Advanced Weather Analysis",
  "premium.premiumFeatureCharts": "Chart Comparisons",
  "premium.premiumFeatureExport": "Data Export",
  "premium.premiumFeatureForecast": "Regional Forecast Models",
  "premium.premiumFeatureNotification": "Status Bar Widget",
  "premium.premiumFeatureTitle": "Premium Feature",
  "premium.premiumFeatureWidgets": "Home Screen Widgets",
  "premium.premiumFreePlan": "Free",
  "premium.premiumInactive": "Not subscribed",
  "premium.premiumManageStoreSubscription": "You subscribed through {store}. Manage or cancel your subscription there.",
  "premium.premiumManageWebSubscription": "Manage your subscription, update payment method, or cancel.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Renews on {date}",
  "premium.premiumSubscribeAnnual": "Annual — 9.99 €/year",
  "premium.premiumSubscribedOn": "Subscribed on {platform}",
  "premium.premiumSubscribedOnWeb": "Subscribed on the web",
  "premium.premiumSubscribeMonthly": "Monthly — 1.99 €/month",
  "premium.premiumSubscribeOnWeb": "Subscribe now to unlock all premium features.",
  "premium.premiumSubscriptionSuccess": "Your subscription has been activated! Enjoy all premium features.",
  "premium.premiumSubscriptionSuccessTitle": "Welcome to Premium!",
  "premium.premiumWebappNotice": "Subscribing on the web is not available right now.",
  "premium.pricePerMonth": "{price}/month",
  "premium.pricePerYear": "{price}/year",
  "premium.purchasedNetatmoPro": "You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features.",
  "premium.purchaseFailed": "Your purchase could not be completed. Please try again.",
  "premium.restoreFailed": "Your purchases could not be restored. Please try again.",
  "premium.restorePurchase": "Restore purchase",
  "premium.savingsPercent": "Save {percent}%",
  "premium.seePremium": "See Premium",
  "premium.startFreeTrial": "Start Free Trial",
  "premium.storeUnavailable": "The store is not available right now. Please try again later.",
  "premium.subscribeNow": "Subscribe now — no trial",
  "premium.switchToPremium": "Switch to SmartMixin Premium",
  "premium.thenPrice": "then {price}",
  "providerHints.ambientWeatherApiKey": "Created in your ambientweather.net account settings.",
  "providerHints.davisApiSecret": "Shown only once when you created the V2 API key — keep it safe.",
  "providerHints.davisV2ApiKey": "From your weatherlink.com V2 API keys page.",
  "providerHints.ecowittApi": "From your Ecowitt account API page.",
  "providerHints.ecowittApp": "The Application key, also from your Ecowitt account.",
  "providerHints.myAcuriteCredentialsBanner": "Use your My AcuRite account email and password — not your SmartMixin login.",
  "providerHints.myAcuriteEmail": "Your My AcuRite account email — not your SmartMixin login.",
  "providerHints.myAcuritePassword": "Your My AcuRite account password.",
  "providerHints.weatherflowToken": "Personal-use token from tempestwx.com → settings → data authorizations.",
  "providerHints.wundergroundEditKey": "Use a different key",
  "providerHints.wundergroundKey": "A long string from your Weather Underground member API keys page — not your wunderground.com password.",
  "providerHints.wundergroundKeyExample": "e.g. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API key verified",
  "providerHints.wundergroundNoStationsNearby": "No stations found near this location. Try entering a station ID directly.",
  "providerHints.wundergroundStationIdExample": "e.g. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Get your Ambient Weather API key.",
  "providerIntro.davisStep2": "Get your Davis V2 API key and API secret.",
  "providerIntro.ecowittStep2": "Get your Ecowitt API key and Application key.",
  "providerIntro.getStarted": "Get started",
  "providerIntro.myAcuriteStep2": "Use your existing My AcuRite account email and password.",
  "providerIntro.netatmoEnergyStep2": "Sign in to Netatmo when prompted — no API key needed.",
  "providerIntro.netatmoWeatherStep2": "Sign in to Netatmo when prompted — no API key needed.",
  "providerIntro.signupBanner": "Almost there — create your free SmartMixin account to connect {provider}.",
  "providerIntro.step1": "Sign in to your SmartMixin account (NOT your {provider} login).",
  "providerIntro.step3EmailPassword": "Enter them here.",
  "providerIntro.step3KeyOrToken": "Paste it here.",
  "providerIntro.step3OAuth": "Authorize SmartMixin in the popup.",
  "providerIntro.step3Wunderground": "Paste your API key, then pick a nearby station or enter any station ID.",
  "providerIntro.title": "Connect {provider}",
  "providerIntro.weatherflowStep2": "Get your Tempest personal-use token.",
  "providerIntro.wundergroundBrowsePublic": "Don't have a station? Browse public ones",
  "providerIntro.wundergroundFindNearby": "Find stations near me",
  "providerIntro.wundergroundOrEnterId": "Or enter a station ID",
  "providerIntro.wundergroundStep2": "Get your Weather Underground API key. You'll then be able to connect any station — yours or a public one.",
  "reports.agroMeteorology": "Agrometeorology",
  "reports.analysis": "Analysis",
  "reports.annualCumulativeRainfallComparison": "Annual Cumulative Rainfall Comparison",
  "reports.annualHeatingDurationComparison": "Annual heating duration comparison",
  "reports.annualHeatingEfficiency": "Annual heating efficiency",
  "reports.annualIndoorComparison": "Annual Indoor Comparison",
  "reports.annualOutdoorComparison": "Annual Outdoor Comparison",
  "reports.annualOutdoorReport": "Annual Outdoor Report",
  "reports.annualReport": "Annual Report",
  "reports.annualSolarReport": "Annual solar report",
  "reports.annualWaterBalance": "Annual water balance",
  "reports.annualWaterBalanceCarryOver": "Carry over {year} ({value})",
  "reports.annualWaterBalanceDescription": "The water balance (simplified version, only Rain and evapotranspiration are used) helps manage water supply",
  "reports.avgHumidity": "Average humidity",
  "reports.avgMaxTemperature": "Average T°max",
  "reports.avgMetric": "Average {metric}",
  "reports.avgMinTemperature": "Average T°min",
  "reports.avgPressure": "Average Pressure",
  "reports.avgTemperature": "Average temperature",
  "reports.chartsAndTable": "Charts and table",
  "reports.climateNormalPeriodOfRecord": "Period of record ({years, plural, one {# year} other {# years}})",
  "reports.climateNormals": "Climate normals",
  "reports.climateNormalStandardLabel": "Standard normal ({period})",
  "reports.climateTrendPerDecade": "Temperature trend: {value} per decade over {years, plural, one {# year} other {# years}}",
  "reports.coldestMonthRanking": "Coldest {month} on record",
  "reports.comfortable": "Comfortable (45% {lessThan} Humidity ≤ 60%)",
  "reports.cumulativeRainfall": "Cumulative rainfall",
  "reports.cumulativeRainfallDescription": "Track total rainfall accumulating over the selected period.",
  "reports.dailyMaxRainfall": "Daily Max. rainfall",
  "reports.dataExport": "Export data",
  "reports.dataExportXlsxFormatDescription": "Export all of your station's data in Excel format (*.xlsx). Once you click on the button, you will receive an email with the processed data after a few minutes.",
  "reports.daysOfData": "{days, plural, one {# day of data} other {# days of data}}",
  "reports.daysWithFrost": "Days with frost",
  "reports.daysWithHeavyRain": "Days with heavy rain (≥ {threshold})",
  "reports.daysWithoutThaw": "Days without thaw",
  "reports.daysWithStrongFrost": "Days with strong frost",
  "reports.emailSent": "An email has been sent to your mailbox",
  "reports.frostDays": "Frost days",
  "reports.grasslandTemperatureSum": "Grassland temperature sum",
  "reports.grasslandTemperatureSumDescription": "If the sum of {threshold} is exceeded in spring, the sustainable start of vegetation has been reached (works in Europe)",
  "reports.growingDegreeDays": "Growing degree days",
  "reports.highPressure": "Anticyclone (Average Pressure ≥ 1013mbar)",
  "reports.iceDays": "Ice days",
  "reports.indoorReport": "Indoor Report",
  "reports.keyFacts": "Key Facts",
  "reports.longestDrySpell": "Longest dry spell",
  "reports.longestRunOfRainyDays": "Longest run of rainy days",
  "reports.longestRunWithoutRun": "Longest run without rain",
  "reports.longestWetSpell": "Longest wet spell",
  "reports.lowPressure": "Low Pressure (Average Pressure {lessThan} 1013mbar)",
  "reports.maxHumidity": "Maximum humidity",
  "reports.maxMetric": "Maximum {metric}",
  "reports.maxPressure": "Maximum Pressure",
  "reports.maxTemperature": "Maximum temperature",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximum Magnitude (/24H)",
  "reports.minHumidity": "Minimum humidity",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimum Pressure",
  "reports.minTemperature": "Minimum temperature",
  "reports.minTempMagnitude24h": "Minimum Magnitude (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# more day this month} other {# more days this month}}",
  "reports.monthlyAverageCountdownDetail": "Then this month's average and ranking appear.",
  "reports.monthlyAverageRule": "Monthly averages and rankings appear once a calendar month has {days, plural, one {# day} other {# days}} recorded.",
  "reports.monthlyHeatingEfficiency": "Monthly heating efficiency",
  "reports.monthlyOutdoorReport": "Monthly Outdoor Report",
  "reports.monthlyReport": "Monthly Report",
  "reports.monthlySolarReport": "Monthly solar report",
  "reports.monthlyWindReport": "Monthly Wind Report",
  "reports.monthsOfData": "{months, plural, one {# month of data} other {# months of data}}",
  "reports.numberOfDays": "Number of Days",
  "reports.outdoorReport": "Outdoor Report",
  "reports.overviewSection": "Overview",
  "reports.rainfall": "Rainfall",
  "reports.rainyDays": "Rainy days",
  "reports.recordDailyRain": "Wettest day",
  "reports.recordHigh": "Record high",
  "reports.recordLow": "Record low",
  "reports.recordsAndClimatology": "Records & climate",
  "reports.recordsSince": "Records since {date}",
  "reports.recordWindGust": "Strongest wind gust",
  "reports.relativelyWet": "Relatively wet (60% {lessThan} Humidity ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# report} other {# reports}}",
  "reports.sendEmail": "Send email",
  "reports.summerDays": "Summer days",
  "reports.tooDry": "Too dry (Humidity ≤ 45%)",
  "reports.tooWet": "Too wet (Humidity {greaterThan} 80%)",
  "reports.tropicalNights": "Tropical nights",
  "reports.unlockPremiumSubtitle": "Included with SmartMixin Premium",
  "reports.unlockPremiumTitle": "Unlock {count, plural, one {# premium feature} other {# premium features}}",
  "reports.warmestMonthRanking": "Warmest {month} on record",
  "reports.waterBalance": "Water balance",
  "reports.yearsOfData": "{years, plural, one {# year of data} other {# years of data}}",
  "reports.yearToDateTemperatureComparison": "Year-to-date temperature comparison",
  "sensors.bgtSensors": "Black globe & WBGT",
  "sensors.cameraFeed": "Camera",
  "sensors.compareHumidity": "Compare humidity",
  "sensors.compareMoisture": "Compare moisture",
  "sensors.comparePm25": "Compare PM2.5",
  "sensors.compareTemperatures": "Compare temperatures",
  "sensors.compareWaterTension": "Compare soil water tension",
  "sensors.depthByChannel": "Depth by channel",
  "sensors.heatStressExtreme": "Extreme heat stress",
  "sensors.heatStressModerate": "Moderate heat stress",
  "sensors.heatStressNone": "No heat stress",
  "sensors.heatStressStrong": "Strong heat stress",
  "sensors.heatStressVeryStrong": "Very strong heat stress",
  "sensors.indoorClimate": "Indoor climate",
  "sensors.indoorCo2Levels": "CO2 levels",
  "sensors.indoorTemperatureAndHumidity": "Temperature & humidity",
  "sensors.leafWetnessByChannel": "Leaf wetness by channel",
  "sensors.lightningSensor": "Lightning",
  "sensors.moistureByChannel": "Moisture by channel",
  "sensors.noDataAvailable": "No data available",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 by channel",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Select channel",
  "sensors.sensorDetailDescription": "View historical data and trends for your sensor channels.",
  "sensors.sensorHistory": "Sensor history",
  "sensors.soilConductivityByChannel": "Conductivity by channel",
  "sensors.soilTemperatureByChannel": "Soil temperature by channel",
  "sensors.strikesToday": "Strikes today",
  "sensors.temperatureByChannel": "Temperature by channel",
  "sensors.viewChart": "View chart",
  "sensors.waterTensionByChannel": "Soil water tension by channel",
  "settings.appearance": "Appearance",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabic",
  "settings.bulgarian": "Bulgarian",
  "settings.catalan": "Catalan",
  "settings.chartGestures": "Gestures on charts",
  "settings.chartGesturesDescription": "Swiping on charts changes the time period, pinching charts changes time scale",
  "settings.choiceCount": "{count, plural, one {# available} other {# available}}",
  "settings.contactUs": "Contact Us",
  "settings.contactUsDescription": "Get help or send feedback",
  "settings.croatian": "Croatian",
  "settings.czech": "Czech",
  "settings.dailyDetailByPeriods": "Daily detail by periods",
  "settings.dailyDetailByPeriodsDescription": "Group the 24 hours into night, morning, afternoon and evening — the same split the daily summary sentence uses.",
  "settings.danish": "Danish",
  "settings.dark": "Dark theme",
  "settings.dataDisplay": "Data display",
  "settings.dateAndTime": "Date and time",
  "settings.donateButton": "Make a donation",
  "settings.donateDescription": "SmartMixin is built by a small team. If you find it useful, you can support its development with a one-time donation of any amount. It's a gift — it doesn't change your plan or unlock any features.",
  "settings.donateSuccessBody": "Your donation helps keep SmartMixin running and improving. We truly appreciate it.",
  "settings.donateSuccessTitle": "Thank you for your support!",
  "settings.donateTitle": "Support SmartMixin",
  "settings.dragToReorder": "Drag to reorder",
  "settings.dutch": "Dutch",
  "settings.english": "English",
  "settings.french": "French",
  "settings.german": "German",
  "settings.gestures": "Gestures",
  "settings.greek": "Greek",
  "settings.hungarian": "Hungarian",
  "settings.italian": "Italian",
  "settings.japanese": "Japanese",
  "settings.korean": "Korean",
  "settings.language": "Language",
  "settings.languageDescription": "Preferred language",
  "settings.light": "Light theme",
  "settings.measurementUnits": "Measurement units",
  "settings.netatmoDashboard": "Netatmo dashboard",
  "settings.netatmoLayoutCards": "Card list",
  "settings.netatmoLayoutCardsDescription": "One card per module, all on one scroll",
  "settings.netatmoLayoutClassic": "Classic",
  "settings.netatmoLayoutClassicDescription": "Two cards, swipe between modules",
  "settings.netatmoNewLayoutNotice": "New dashboard layout: one card per module.",
  "settings.netatmoSwitchBackToClassic": "Switch back to Classic",
  "settings.netatmoSwitchToLayout": "Switch to {layout}",
  "settings.norwegian": "Norwegian",
  "settings.notificationsSection": "Notifications",
  "settings.ongoingNotificationEnabled": "Enable ongoing notification",
  "settings.ongoingNotificationMetrics": "Displayed metrics",
  "settings.ongoingNotificationPermissionRequired": "Notification permission is required",
  "settings.ongoingNotificationPreviewHint": "Preview — turn the widget on to show it",
  "settings.ongoingNotificationStatusBar": "Status bar",
  "settings.polish": "Polish",
  "settings.portuguese": "Portuguese",
  "settings.preferencesSection": "Preferences",
  "settings.privacyPolicy": "Privacy policy",
  "settings.russian": "Russian",
  "settings.serbian": "Serbian",
  "settings.settings": "Settings",
  "settings.settingsPageTitle": "Settings - {page}",
  "settings.slovak": "Slovak",
  "settings.smallDecimals": "Small decimals",
  "settings.smallDecimalsDescription": "Display decimal digits in a smaller size",
  "settings.spanish": "Spanish",
  "settings.statusBarWidget": "Status Bar Widget",
  "settings.statusBarWidgetDescription": "Always-visible weather data",
  "settings.subscriptionSection": "Subscription",
  "settings.supportSection": "Support",
  "settings.swedish": "Swedish",
  "settings.systemTheme": "System theme",
  "settings.termsOfService": "Terms of service",
  "settings.turkish": "Turkish",
  "settings.ukrainian": "Ukrainian",
  "settings.units": "Units",
  "settings.unitsDescription": "Measurement units displayed within the application",
  "settings.update": "Update",
  "settings.windDirectionConvention": "Wind direction arrow",
  "settings.windDirectionConventionDescription": "Choose how wind direction arrows are displayed",
  "settings.windDirectionMeteorological": "Origin direction",
  "settings.windDirectionMeteorologicalDescription": "Arrow points where the wind comes from (meteorological convention)",
  "settings.windDirectionOceanographic": "Flow direction",
  "settings.windDirectionOceanographicDescription": "Arrow points where the wind blows to (oceanographic convention)",
  "stations.addAStation": "Add a station",
  "stations.addToFavorites": "Add to favorites",
  "stations.addYourOwnStation": "Add your own station",
  "stations.clearRecentLocations": "Clear all",
  "stations.clearSearch": "Clear search",
  "stations.currentLocation": "Current location",
  "stations.customizedStationName": "Customized station name",
  "stations.favoriteLocations": "Favorites",
  "stations.favoriteLocationsEmpty": "You can add up to 5 favorite locations.",
  "stations.favoriteStations": "Favorite stations",
  "stations.filterStationDescription": "Do not display stations with unreliable measures",
  "stations.filterStations": "Filter stations",
  "stations.filterStationSourceDescription": "Select station providers that you want to display on the map",
  "stations.findStationsNearYou": "Find Stations Near You",
  "stations.hiddenStations": "Hidden stations",
  "stations.hiddenStationsDescription": "You can unhide a station by tapping the eye icon next to it.",
  "stations.lastSeen": "last seen {time}",
  "stations.location": "Location",
  "stations.locationAddedToFavorites": "Location added to favorites",
  "stations.locationNotGranted": "Location permission is not granted. Please allow access to your location in device settings.",
  "stations.locationRemovedFromFavorites": "Location removed from favorites",
  "stations.locations": "Locations",
  "stations.locationUnavailable": "Unable to get your location. Please check your device settings.",
  "stations.maxFavoriteLocationsReached": "You can only have up to 5 favorite locations. Remove one to add another.",
  "stations.modifyFavoriteStations": "Modify favorite stations",
  "stations.modifyFavoriteStationsDescription": "You can reorder your favorite stations by dragging them. You can also remove them from the list.",
  "stations.myLocation": "My location",
  "stations.nearbyWeatherStations": "Nearby weather stations",
  "stations.noLocationsFound": "No locations found",
  "stations.noSearchResults": "No articles match your search",
  "stations.noStationsFound": "No Stations Found",
  "stations.noWeatherStationYet": "You don't have a weather station yet.",
  "stations.recentLocations": "Recent",
  "stations.recentLocationsEmpty": "Your recent history is empty.",
  "stations.removeFromFavorites": "Remove from favorites",
  "stations.searchForLocation": "Search for a location",
  "stations.searchForWeatherStation": "Search for a weather station",
  "stations.searchResults": "Search results",
  "stations.searchResultsEmpty": "No results found.",
  "stations.searchResultsFound": "{count, plural, one {# result found} other {# results found}}",
  "stations.searchStationsDescription": "Enter a city, address, or place name to find weather stations nearby.",
  "stations.searchStationsHint": "Use the search bar above to discover weather stations in any location around the world.",
  "stations.selectStationForComparison": "Select a station to compare with",
  "stations.stationAddedToFavorites": "Station added to favorites",
  "stations.stationCount": "{count, plural, one {# station} other {# stations}}",
  "stations.stationInformation": "Station information",
  "stations.stationName": "Station name",
  "stations.stationObservationsDescription": "Display the latest observations from weather stations",
  "stations.stationRemovedFromFavorites": "Station removed from favorites",
  "stations.stationsNear": "Stations near {place}",
  "stations.stationType": "Station type",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Stale",
  "stations.tryAnotherLocation": "We couldn't find any weather stations near this location. Try searching for a different area.",
  "stations.weatherStation": "Weather station",
  "stations.weatherStationCount": "{count, plural, one {# weather station} other {# weather stations}}",
  "stations.weatherStations": "Weather stations",
  "stations.welcomeConnectService": "Own a weather station? Connect your service",
  "stations.welcomeSubtitle": "Your weather, all in one place",
  "thermostat.away": "Away",
  "thermostat.boilerOn": "Boiler ON",
  "thermostat.hg": "Frost guard",
  "thermostat.homeInformation": "Home information",
  "thermostat.homeName": "Home name",
  "thermostat.manualBoost": "Manual boost",
  "thermostat.manualSetpointUntil": "Manual setpoint until",
  "thermostat.noThermostatYet": "You don't have a thermostat yet.",
  "thermostat.relay": "Relay",
  "thermostat.room": "Room",
  "thermostat.rooms": "Rooms",
  "thermostat.smartThermostat": "Smart thermostat",
  "thermostat.smartValve": "Smart valve",
  "thermostat.whenBackHome": "When will you be back home?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Inches",
  "units.inchOfMercury": "Inches of mercury",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometers per hour",
  "units.knot": "Knots",
  "units.meterPerSecond": "Meters per second",
  "units.milePerHour": "Miles per hour",
  "units.millibar": "Millibars",
  "units.millimeter": "Millimeters",
  "units.millimeterOfMercury": "Millimeters of mercury",
  "weatherConditions.blizzard": "Blizzard",
  "weatherConditions.blowingDust": "Blowing dust",
  "weatherConditions.blowingSnow": "Blowing snow",
  "weatherConditions.breezy": "Breezy",
  "weatherConditions.clear": "Clear",
  "weatherConditions.cloudy": "Cloudy",
  "weatherConditions.drizzle": "Drizzle",
  "weatherConditions.flurries": "Flurries",
  "weatherConditions.foggy": "Fog",
  "weatherConditions.freezingDrizzle": "Freezing drizzle",
  "weatherConditions.freezingRain": "Freezing rain",
  "weatherConditions.frigid": "Frigid",
  "weatherConditions.hail": "Hail",
  "weatherConditions.haze": "Haze",
  "weatherConditions.heavyRain": "Heavy rain",
  "weatherConditions.heavySnow": "Heavy snow",
  "weatherConditions.hot": "Hot",
  "weatherConditions.hurricane": "Hurricane",
  "weatherConditions.isolatedThunderstorms": "Isolated thunderstorms",
  "weatherConditions.mixedRainAndHail": "Rain and hail",
  "weatherConditions.mostlyClear": "Mostly clear",
  "weatherConditions.mostlyCloudy": "Mostly cloudy",
  "weatherConditions.mostlySunny": "Mostly sunny",
  "weatherConditions.notAvailable": "Weather conditions unavailable",
  "weatherConditions.partlyCloudy": "Partly cloudy",
  "weatherConditions.rain": "Rain",
  "weatherConditions.rainSleet": "Rain and sleet",
  "weatherConditions.rainSnow": "Rain and snow",
  "weatherConditions.scatteredShowers": "Scattered showers",
  "weatherConditions.scatteredSnowShowers": "Scattered snow showers",
  "weatherConditions.scatteredThunderstorms": "Scattered thunderstorms",
  "weatherConditions.showers": "Showers",
  "weatherConditions.sleet": "Sleet",
  "weatherConditions.smoke": "Smoke",
  "weatherConditions.snow": "Snow",
  "weatherConditions.snowShowers": "Snow showers",
  "weatherConditions.strongStorms": "Strong storms",
  "weatherConditions.sunny": "Sunny",
  "weatherConditions.thunderstorms": "Thunderstorms",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropical storm",
  "weatherConditions.windy": "Windy",
  "weatherConditions.wintryMix": "Wintry mix",
  "weatherMap.legendHeavy": "Heavy",
  "weatherMap.legendLight": "Light",
  "weatherMap.legendLightningHelp": "Colour shows each strike's age over the last {minutes} minutes — most recent in white, oldest in dark red.",
  "weatherMap.legendNewest": "Newest",
  "weatherMap.legendOldest": "Oldest",
  "weatherMap.legendStationsHelp": "Marker colour reflects the value of the selected metric.",
  "weatherMap.lightningDataAttribution": "Lightning data: Blitzortung.org",
  "weatherMap.lightningStrikes": "Lightning strikes",
  "weatherMap.lightningStrikesDescription": "Display real-time lightning strikes on the map",
  "weatherMap.mapLayers": "Map layers",
  "weatherMap.mapLegend": "Map legend",
  "weatherMap.radarDataAttribution": "Radar data: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Rain radar",
  "weatherMap.rainRadarDescription": "Display rain radar overlay on the map",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level",
  "weatherMap.weatherMap": "Weathermap",
  "weatherMap.weatherMapMetaDescription": "SmartMixin provides interactive weather and radar maps for weather conditions for locations worldwide.",
  "weatherWarnings.activeNow": "Active now",
  "weatherWarnings.fromTime": "From {time}",
  "weatherWarnings.hazardAirQuality": "Air quality",
  "weatherWarnings.hazardAvalanche": "Avalanches",
  "weatherWarnings.hazardCoastalEvent": "Coastal hazards",
  "weatherWarnings.hazardFlood": "Floods",
  "weatherWarnings.hazardFog": "Fog",
  "weatherWarnings.hazardForestFire": "Forest fires",
  "weatherWarnings.hazardHighTemperature": "High temperatures",
  "weatherWarnings.hazardLowTemperature": "Low temperatures",
  "weatherWarnings.hazardOther": "Other hazard",
  "weatherWarnings.hazardRain": "Rain",
  "weatherWarnings.hazardSnowIce": "Snow and ice",
  "weatherWarnings.hazardThunderstorm": "Thunderstorms",
  "weatherWarnings.hazardUv": "UV radiation",
  "weatherWarnings.hazardWind": "Wind",
  "weatherWarnings.lastUpdate": "Last update: {time}",
  "weatherWarnings.severityExtreme": "Extreme",
  "weatherWarnings.severityFrom": "{severity} from {time}",
  "weatherWarnings.severityMinor": "Minor",
  "weatherWarnings.severityModerate": "Moderate",
  "weatherWarnings.severityNow": "{severity} now",
  "weatherWarnings.severitySevere": "Severe",
  "weatherWarnings.severityUntil": "{severity} until {time}",
  "weatherWarnings.source": "Source: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, then {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# official weather warning} other {# official weather warnings}}. {hazards}",
  "weatherWarnings.upcoming": "Upcoming"
}
